export default function Geocode(query, params) {
    const header = {'Content-Type': 'application/json'};
    let path = 'https://api.mapbox.com/geocoding/v5/mapbox.places/' + encodeURIComponent(query) + '.json?access_token=pk.eyJ1IjoiZGF2aWRnb2xkZW4iLCJhIjoiY2pwZW5oamdwMDIyejNrbzhrMGc4YzlqNiJ9.klBRb1BeqxvmJjqi9f-8yw';

    params.forEach(param => {
        path += `&${param.type}=${param.value}`;
    });

    if (query.length > 2) {
        return fetch(path, {
            headers: header,
        }).then(res => {
            if (!res.ok) {
                throw Error(res.statusText);
            }
            return res.json();
        }).then(json => {
            return json.features;
        }).catch(err => {
            return err;
        })
    } else {
        return [];
    }
}
